
<template>
  <div class="main-content">

    <loading :active.sync="isLoading"
             :is-full-page="fullPage"></loading>

    <div class="row">
      <div class="col-md-12">
        <h2>Partners report</h2>
      </div>
    </div>

    <hr/>


    <div class="row" style="margin-bottom: 20px;">
      <div class="col-md-6">
        <div>
          By date:
        </div>

        <date-picker   :lang="lang" v-model="start_date" valueType="format" :first-day-of-week="1"></date-picker> to
        <date-picker   :lang="lang" v-model="end_date" valueType="format" :first-day-of-week="1"></date-picker> &nbsp;&nbsp;
        <button type="button" class="btn btn-danger" @click="getPartnerTransactionsData">Filter</button>

      </div>
    </div>
    <br/>

    <div >
      <b-table striped hover :items="transactions" :fields="columns">
        <template #cell(no)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(customer)="data">
          {{ data.item.transaction.customer.name }}
        </template>

        <template v-slot:cell(partner)="data">
          <span>{{ data.item.partner.name }}</span>
        </template>
        <template v-slot:cell(outlet)="data">
          {{ data.item.transaction.outlet.name }}
        </template>
        <template v-slot:cell(narration)="data">
          {{ data.item.transaction.narration }}
        </template>
        <template v-slot:cell(transactionType)="data">
        <span  class="badge badge-danger"  v-if="data.item.transaction.transactionType == 'ACCRUAL'">
							Accrual
						</span>
          <span class="badge badge-success"  v-else >
							Redemption
        </span>
        </template>

        <template v-slot:cell(transactionApprovalStatus)="data">
          <div v-if="data.value != null" >
							<span  class="badge badge-success"  v-if="data.value == 'APPROVED'" >
								Accepted
							</span>
            <span  class="badge badge-warning"  v-else-if="data.value == 'PENDING'" >
								Pending
							</span>

            <span class="badge badge-danger"  v-else >
								Reversed
							</span>
          </div>
          <div v-else>
							<span   class="badge badge-info" >
								Accepted
							</span>
          </div>
        </template>

      </b-table>
    </div>

    <div class="row">
      <div class="col-md-12">

        <nav aria-label="Page navigation float-right" style="margin-top: 20px;">
          <ul class="pagination justify-content-center">
            <li v-if="pagination.current_page > 1" class="page-item"><a @click.prevent="changePage(pagination.current_page - 1)" class="page-link" href="#">Previous</a></li>
            <li v-for="page in pagesNumber"
                v-bind:class="[ page == isActived ? 'active' : '']" class="page-item"><a @click.prevent="changePage(page - 1)" class="page-link" href="#">{{ page }}</a></li>
            <li v-if="pagination.current_page < pagination.last_page"  class="page-item"><a  @click.prevent="changePage(pagination.current_page + 1)"class="page-link" href="#">Next</a></li>
          </ul>
        </nav>
      </div>
    </div>


  </div>
</template>
<script>

  import { mapGetters, mapActions } from "vuex";

  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import Multiselect from 'vue-multiselect'

export default {
  data() {
    return {
      email_address:"",
      reversal_comments:"",
      disabled:false,
      isLoading: false,
      fullPage: true,
      pagination: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 0
      },
      loyaltyStats:{
        totalPoints:0,
        pointsAccruedToday:0,
        totalPointsToday:0,
        redeemedToday:0,
      },
      merchantStats:{
        pointsValue:0,
        pointsAccrued:0,
        pointsAccruedToday:0,
        redeemedToday:0
      },
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      offset: 4,
      columns:["created","customer","partner","outlet","totalLoyaltyPoints","transactionType","narration","loyaltyPoints"],
      transactions:[],
      start_date:"all",
      end_date:"all",
      outlet:null,
      outlets:[],
      transaction:{
        customer:{
          name:""
        },
        loyaltyPoints:0
      },
      transaction_type:"Accrual",
      approval_type:"ALL"

    };
  },
  computed:{
    isActived: function () {
      return this.pagination.current_page + 1;
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return [];
      }
      var from = this.pagination.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }
      var to = from + (this.offset * 2);
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      var pagesArray = [];
      while (from <= to) {
        pagesArray.push(from);
        from++;
      }
      return pagesArray;
    },
    permissions(){
      return localStorage.getItem("permissions");
    },
    role(){
      return localStorage.getItem("role");
    }
  },
  components: {
    Loading,
    DatePicker,
    Multiselect
  },
  mounted (){
    this.getPartnerTransactionsData();

  },
  methods: {
    ...mapActions(["getPartnerTransactions", "getOutlets","getLoyaltyStats","reverseTransaction","getOutletsByUserId","getMerchantStats","exportTransactionsData"]),

    openReverseTransactionModal(transaction){

        this.transaction = transaction;

      this.$bvModal.show("reverse-transaction")


    },


    changePage: function (page) {
      this.pagination.current_page = page;
      this.getTransactionsData();
    },
    getPartnerTransactionsData(){
      let self = this;
      this.isLoading = true;

      this.getPartnerTransactions()
        .then(function (transactions) {

          self.isLoading = false;

          self.transactions = transactions.map(function (transaction){
            let tempTransaction = transaction;
            tempTransaction.narration = "N/A";
            tempTransaction.transactionType = "N/A";
            tempTransaction.customer = "N/A";
            tempTransaction.outlet = "N/A";
            return tempTransaction;
          });
        })
        .catch(function (error) {

          self.isLoading = false;


        })
    }
  }
};
</script>
